export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            联系我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">
            投稿与合作
          </h2>
          <p className="text-sm text-foreground-500 mb-8 max-w-lg mx-auto">
            如果你有完结漫画资源推荐、合作意向或任何建议，欢迎通过以下方式联系我们。亲亲漫画网期待与更多漫画爱好者交流。
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="bg-background-50 border border-background-200 rounded-xl p-5 hover:border-primary-200 transition-colors cursor-pointer">
              <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 mx-auto mb-3">
                <i className="ri-mail-line text-lg"></i>
              </span>
              <div className="text-sm font-medium text-foreground-800 mb-1">邮件联系</div>
              <div className="text-xs text-foreground-500">contact@qinqinmanga.com</div>
            </div>

            <div className="bg-background-50 border border-background-200 rounded-xl p-5 hover:border-accent-200 transition-colors cursor-pointer">
              <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-50 text-accent-500 mx-auto mb-3">
                <i className="ri-chat-3-line text-lg"></i>
              </span>
              <div className="text-sm font-medium text-foreground-800 mb-1">资源投稿</div>
              <div className="text-xs text-foreground-500">提交完结漫画资源</div>
            </div>

            <div className="bg-background-50 border border-background-200 rounded-xl p-5 hover:border-secondary-200 transition-colors cursor-pointer">
              <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-50 text-secondary-500 mx-auto mb-3">
                <i className="ri-shake-hands-line text-lg"></i>
              </span>
              <div className="text-sm font-medium text-foreground-800 mb-1">商务合作</div>
              <div className="text-xs text-foreground-500">广告及推广洽谈</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}